// components/PrivacyBanner.js
import { useState, useEffect } from 'react';
import './PrivacyBanner.css';

function PrivacyBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('privacyConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('privacyConsent', 'accepted');
    localStorage.setItem('consentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleDecline = () => {
    // Show alert explaining the consequences
    alert(
      "To sign up and use personalized features (favorites, ratings, user account), you must accept our privacy policy. " +
      "You can continue browsing books as a guest, but won't be able to save preferences or create an account."
    );
    
    localStorage.setItem('privacyConsent', 'declined');
    localStorage.setItem('userMode', 'guest');
    
    // Clear any existing user data
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    
    setShowBanner(false);
    
    // Optional: You could also reload the page to ensure clean state
    window.location.reload();
  };
  

  if (!showBanner) return null;

  return (
    <div className="privacy-banner">
      <div className="privacy-content">
        <h3>Privacy & Data Usage</h3>
        <p>
          We use local storage to save your preferences, favorites, and ratings. 
          We also collect usage data to improve our service. By continuing, you 
          agree to our data practices.
        </p>
        <div className="privacy-buttons">
          <button onClick={handleAccept} className="accept-btn">
            Accept
          </button>
          <button onClick={handleDecline} className="decline-btn">
            Decline
          </button>
          <a href="/privacy-policy" className="privacy-link">
            Read Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
}

export default PrivacyBanner;
